import React, { useState } from 'react';
import { Input, Tag } from 'antd';

const VariantTagInput = ({ existingValues, onAddValue }) => {
    const [inputValue, setInputValue] = useState('');

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const val = inputValue.trim();
            if (val) {
                // Check for duplicates case-insensitively
                const isDuplicate = existingValues.some(ev => ev.toLowerCase() === val.toLowerCase());
                if (!isDuplicate) {
                    onAddValue(val);
                }
                setInputValue('');
            }
        }
    };

    return (
        <div style={{ marginBottom: '12px' }}>
            <div style={{ fontSize: '11px', fontWeight: 800, color: '#475569', textTransform: 'uppercase', marginBottom: '4px' }}>
                Add Variant Value
            </div>
            <Input
                placeholder="e.g. Black, Red (Press Enter to add)"
                value={inputValue}
                onChange={e => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                size="middle"
                style={{ borderRadius: '8px' }}
            />
        </div>
    );
};

export default React.memo(VariantTagInput);
